export const CUE_VISUALIZE_WORKFLOW_CTA = {
  ctaId: 'workflows_visualize_workflow_cta',
  viewEvent: 'workflows:cue_visualize_workflow_button_view',
  clickEvent: 'workflows:cue_visualize_workflow_button_click',
} as const;
